module.exports = __webpack_public_path__ + "static/media/03.-4-5.411d260d.jpg";